import Stack from "@mui/material/Stack";
import { useQuantityTypes } from "@/pages-components/products/digital-offset-price/widgets/render-parameter-widgets/quantity-parameter/quantity-types/use-quantity-types";
import { FormInput } from "@/components/form-inputs/form-input";
import { PrimarySwitch } from "@/components";
import { useTranslation } from "react-i18next";
import { useStyle } from "@/pages-components/products/digital-offset-price/widgets/render-parameter-widgets/quantity-parameter/quantity-types/style";
import { SecondaryButton } from "@/components/button/secondary-button";
import { QuantityTypesTable } from "@/pages-components/products/digital-offset-price/widgets/render-parameter-widgets/quantity-parameter/table/quantity-types-table";
import { useRecoilValue } from "recoil";
import { subProductsParametersState } from "@/store";

const QuantityTypesComponent = ({ subSection, section, validateParameters, setCanCalculation }) => {
  const { inputs, isDuplicateName, toggleDuplicateName, save, setSave, onDeleteQuantityType } =
    useQuantityTypes({ subSection, section });
  const subProducts = useRecoilValue<any>(subProductsParametersState);
  const { t } = useTranslation();
  const { classes } = useStyle();
  return (
    <Stack direction={"column"} height={"100%"} gap={"7px"}>
      <Stack direction={"row"} gap={"3%"} flexWrap={"wrap"}>
        {inputs.map((input) => (
          <Stack width={"45%"} paddingTop={"10px"} paddingBottom={"10px"}>
            <FormInput
              readonly={!!input.readonly}
              input={input}
              changeState={input.onChange}
              error={false}
            />
          </Stack>
        ))}
      </Stack>
      <Stack direction={"row"} alignItems={"center"} padding={"15px 0px"}>
        <PrimarySwitch
          checked={isDuplicateName}
          onChange={toggleDuplicateName}
        />
        <span style={classes.duplicateName}>{t("sales.quote.duplicateName")}</span>
      </Stack>
      <Stack padding={"0 2px"} width={"100%"} overflow={"hidden"}>
        <QuantityTypesTable onSave={() => { }} save={save} onDeleteQuantityType={onDeleteQuantityType} />
      </Stack>
      <Stack marginTop={"auto"} style={{ backgroundColor: "white" }}>
        <SecondaryButton
          onClick={() => {
            setSave(true);
            let checkParameter = validateParameters(subProducts);
            if (checkParameter) {
              setCanCalculation(true);
            } else {
              setCanCalculation(false);
            }
          }}
          style={{ width: "100%" }}
          variant={"contained"}
        >
          {t("sales.quote.save")}
        </SecondaryButton>
      </Stack>
    </Stack>
  );
};

export { QuantityTypesComponent };
